import { combineReducers, configureStore } from '@reduxjs/toolkit'
export const NODE_ENV: string = import.meta.env.VITE_NODE_ENV || ''
import storeReducer from 'store/store'

const rootReducer = combineReducers({ store: storeReducer })

export const reduxStore = configureStore({ reducer: rootReducer, middleware: (getDefaultMiddleware) => getDefaultMiddleware(), devTools: NODE_ENV !== 'production' })
export type AppDispatch = typeof reduxStore.dispatch

export default reduxStore